
/**
 * Enum for Label position
 */
export enum LABEL_POSITION {
  LEFT = "left",
  RIGHT = "right",
  TOP = "top",
  BOTTOM = "bottom",
}

/**
 * Enum for orientation
 */
export enum ORIENTATION {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}

/**
 * Enum for elements of each node
 */
export enum Elements {
  LabelDescription = "LabelDescription",
  LabelTitle = "LabelTitle",
  ActiveLabelTitle = "ActiveLabelTitle",
  ActiveLabelDescription = "ActiveLabelDescription",
  LineSeparator = "LineSeparator",
  InactiveLineSeparator = "InactiveLineSeparator",
  Node = "Node",
  ActiveNode = "ActiveNode",
  InActiveNode = "InActiveNode",
  CompletedNode = "CompletedNode"
}
